import { api } from './api';

// Endpoints de categoria — leitura sem auth (storefront pode listar), escrita
// exige owner/staff. Sempre incluem `Host`/`X-Store-Slug` automaticamente
// (includeStore default = true).
export const categoryService = {
  list: () => api.get('/api/categories'),
  tree: () => api.get('/api/categories/tree'),
  create: (data) => api.post('/api/categories', data),
  update: (id, data) => api.patch(`/api/categories/${id}`, data),
  remove: (id) => api.delete(`/api/categories/${id}`),
  reorder: (items) => api.patch('/api/categories/reorder', { items })
};

export default categoryService;
